$w.onReady(function () {
$w("#text56").onClick(() => {
    $w("#Classification").changeState("expandedClassification");
});

$w("#vectorImage1").onClick(() => {
    $w("#Classification").changeState("collapsedClassification");
});
});
$w.onReady(function () {
$w("#text57").onClick(() => {
    $w("#Symbolization").changeState("expandedSymbolization");
});

$w("#vectorImage2").onClick(() => {
    $w("#Symbolization").changeState("collapsedSymbolization");
});
});
$w.onReady(function () {
$w("#text58").onClick(() => {
    $w("#Discrimination").changeState("expandedDiscrimination");
});

$w("#vectorImage3").onClick(() => {
    $w("#Discrimination").changeState("collapsedDiscrimination");
});
});
$w.onReady(function () {
$w("#text59").onClick(() => {
    $w("#Dehuminization").changeState("expandedDehuminization");
});

$w("#vectorImage4").onClick(() => {
    $w("#Dehuminization").changeState("collapsedDehuminization");
});
});
$w.onReady(function () {
$w("#text60").onClick(() => {
    $w("#Organization").changeState("expandedOrganization");
});

$w("#vectorImage5").onClick(() => {
    $w("#Organization").changeState("collapsedOrganization");
});
});
$w.onReady(function () {
$w("#text61").onClick(() => {
    $w("#Polarization").changeState("expandedPolarization");
});

$w("#vectorImage6").onClick(() => {
    $w("#Polarization").changeState("collapsedPolarization");
});
});
$w.onReady(function () {
$w("#text62").onClick(() => {
    $w("#Preparation").changeState("expandedPreparation");
});

$w("#vectorImage7").onClick(() => {
    $w("#Preparation").changeState("collapsedPreparation");
});
});
$w.onReady(function () {
$w("#text63").onClick(() => {
    $w("#Persecution").changeState("expandedPersecution");
});

$w("#vectorImage8").onClick(() => {
    $w("#Persecution").changeState("collapsedPersecution");
});
});
$w.onReady(function () {
$w("#text64").onClick(() => {
    $w("#Extermination").changeState("expandedExtermination");
});

$w("#vectorImage9").onClick(() => {
    $w("#Extermination").changeState("collapsedExtermination");
});
});
$w.onReady(function () {
$w("#text65").onClick(() => {
    $w("#Denial").changeState("expandedDenial");
});

$w("#vectorImage10").onClick(() => {
    $w("#Denial").changeState("collapsedDenial");
});
});